export default [
	{
		title: 'Dashboard',
		url: '/',
		externalUrl: null,
		children: null,
		megamenu: null,
		action: null,
		mobile: true,
		published: true,
	},
	{
		title: 'Posillico Materials',
		url: '/materials/dashboard',
		externalUrl: null,
		children: [
			{
				title: 'Desktop Navigation',
				url: '/materials/desktop-navigation',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Mobile Navigation',
				url: '/materials/mobile-navigation',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Sections Index',
				url: '/materials/pages',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Articles Index',
				url: '/materials/articles',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Popup Window',
				url: '/materials/popups',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Contacts',
				url: '/contacts',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
				mobile: true,
				published: true,
			},
			{
				title: 'SEO',
				url: '/materials/seo',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
		],
		megamenu: null,
		action: null,
		mobile: true,
		published: true,
		permission: 'view-materials',
	},
	{
		title: 'Posillico Washplant',
		url: '/washplant/dashboard',
		externalUrl: null,
		children: [
			{
				title: 'Desktop Navigation',
				url: '/washplant/desktop-navigation',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Mobile Navigation',
				url: '/washplant/mobile-navigation',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Sections Index',
				url: '/washplant/pages',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Articles Index',
				url: '/washplant/articles',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Popup Window',
				url: '/washplant/popups',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Contacts',
				url: '/contacts',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
				mobile: true,
				published: true,
			},
			{
				title: 'SEO',
				url: '/washplant/seo',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
		],
		megamenu: null,
		action: null,
		mobile: true,
		published: true,
		permission: 'view-washplant',
	},
	{
		title: 'PPark',
		url: '/ppark/dashboard',
		externalUrl: null,
		children: [
			{
				title: 'Mobile Navigation',
				url: '/ppark/mobile-navigation',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Sections Index',
				url: '/ppark/pages',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Products',
				url: '/ppark/products',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Services',
				url: '/ppark/services',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Associations',
				url: '/ppark/affiliates-associations',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'FAQ',
				url: '/ppark/faq',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Testimonials',
				url: '/ppark/testimonials',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Forms',
				url: '/ppark/forms',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Contact Persons',
				url: '/ppark/contact-persons',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Site Settings',
				url: '/ppark/site-settings',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
		],
		megamenu: null,
		action: null,
		mobile: true,
		published: true,
		permission: 'view-ppark',
	},
	{
		title: 'Construx',
		url: '/construx/dashboard',
		externalUrl: null,
		children: [
			{
				title: 'Mobile Navigation',
				url: '/construx/mobile-navigation',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Sections Index',
				url: '/construx/pages',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Products',
				url: '/construx/products',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Services',
				url: '/construx/services',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			// {
			// 	title: 'Associations',
			// 	url: '/construx/affiliates-associations',
			// 	externalUrl: null,
			// 	children: null,
			// 	megamenu: null,
			// 	action: null,
			// },
			{
				title: 'Clients',
				url: '/construx/clients',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Locations',
				url: '/construx/locations',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Contact Persons',
				url: '/construx/contact-persons',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Home Slider',
				url: '/construx/home-slider',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
			{
				title: 'Testimonials',
				url: '/construx/testimonials',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
			},
		],
		megamenu: null,
		action: null,
		mobile: true,
		published: true,
		permission: 'view-construx',
	},
	{
		title: 'Assets',
		url: '/assets',
		externalUrl: null,
		children: [
			{
				title: 'Posillico Project Icons',
				url: '/settings/project-icons',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
				permission: 'view-project-icons',
			},
		],
		megamenu: null,
		action: null,
		mobile: true,
		published: true,
		permission: 'view-assets',
	},
	{
		title: 'CMS Settings',
		url: null,
		externalUrl: null,
		children: [
			{
				title: 'CMS Users',
				url: '/users',
				externalUrl: null,
				megamenu: null,
				action: null,
				mobile: true,
				published: true,
				permission: 'view-users',
			},
			{
				title: 'Permissions',
				url: '/settings/permissions',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
				permission: 'view-permissions',
			},
			{
				title: 'Constants',
				url: '/settings/constants',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
				permission: 'view-constants',
			},
			{
				title: 'Email Logs',
				url: '/settings/logs/email',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
				permission: 'view-logs',
			},
			{
				title: 'Email Test Kit',
				url: '/settings/email-test',
				externalUrl: null,
				children: null,
				megamenu: null,
				action: null,
				permission: 'view-email-test-kit',
			},
		],
		megamenu: null,
		action: null,
		mobile: true,
		published: true,
		permission: 'view-settings',
	},
];
